import { MatjrahClient } from "../client";
import { request } from "../request";

/**
 * Store-data endpoints are scoped to one app. Calling them before the page has
 * resolved which app is open used to fall back to a hardcoded ID, which sent
 * the request to an unrelated app — rejected as `editor_scope_forbidden` under
 * an OC editor token, and silently answered with the wrong catalogue
 * otherwise. Refuse to build the URL instead.
 */
const scopedAppID = () => {
  const appID = MatjrahClient.currentAppID;
  if (appID === null || appID === undefined || appID === "") {
    throw new Error("لم يتم تحديد التطبيق بعد. أعد تحميل الصفحة وحاول مرة أخرى.");
  }

  return appID;
};

export default {
  // Async so an unscoped call rejects like any other failed request instead of
  // throwing synchronously out of Promise.allSettled callers.
  getCategories: async () => request(`storeData/categories/${scopedAppID()}`),
  getManufacturers: async () => request(`storeData/brands/${scopedAppID()}`),
  getInformation: async () => request(`storeData/information/${scopedAppID()}`),
  getProductById: async ({ product_id }) =>
    request(
      `storeData/productDetails/${scopedAppID()}?product_id=${product_id}`
    ),
  searchProducts: async ({ searchKeyword }) =>
    request(
      `storeData/searchProducts/${scopedAppID()}?search=${encodeURIComponent(searchKeyword)}&page=1&limit=12`
    ),
};
